import type { CSSProperties } from 'react';

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return (parts.length === 1 ? parts[0]!.slice(0, 2) : parts[0]![0]! + parts[1]![0]!).toUpperCase();
}

/** Readable initials color for a background (WCAG relative luminance). */
export function textOn(hex: string): string {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex);
  if (!m) return '#fff';
  const n = parseInt(m[1]!, 16);
  const lin = (c: number) => {
    const v = c / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  };
  const l = 0.2126 * lin((n >> 16) & 255) + 0.7152 * lin((n >> 8) & 255) + 0.0722 * lin(n & 255);
  // Contrast vs white is (1.05)/(l+0.05); prefer dark text once white drops below 4.5:1.
  return 1.05 / (l + 0.05) >= 4.5 ? '#fff' : '#1a1a2e';
}

export function Avatar({
  name,
  color,
  size = 32,
  ring,
  title,
}: {
  name: string;
  color: string;
  size?: number;
  ring?: boolean;
  title?: string;
}) {
  const style: CSSProperties = {
    width: size,
    height: size,
    borderRadius: '50%',
    background: color,
    color: textOn(color),
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: Math.round(size * 0.4),
    fontWeight: 700,
    flex: 'none',
    boxShadow: ring ? '0 0 0 2px var(--surface)' : undefined,
    userSelect: 'none',
  };
  return (
    <span style={style} title={title ?? name} aria-label={title ?? name} role="img">
      {initials(name)}
    </span>
  );
}
